import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=69563f5a&"
import script from "./Accessibility.vue?vue&type=script&lang=ts&"
export * from "./Accessibility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports